import script from "./CallStickyAudioplayerPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./CallStickyAudioplayerPanel.vue?vue&type=script&setup=true&lang=js"

import "./CallStickyAudioplayerPanel.vue?vue&type=style&index=0&id=681c1c81&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-681c1c81"]])

export default __exports__